<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

import { cn } from '@/lib/utils';

const props = defineProps<{ class?: HTMLAttributes['class']; testId?: string }>();
</script>

<template>
  <div
    :data-testid="`${props.testId}-footer`"
    :class="
      cn(
        'flex flex-col-reverse bg-gray-100 border-t border-t-gray-200 rounded-b-2xl px-5 py-4 sm:flex-row sm:justify-end sm:gap-x-2',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
